<template>
  <div style="padding-bottom: 50px">
    <div style="margin: 0 6px 10px 6px;">
      <el-date-picker
        v-model="date"
        :clearable="false"
        type="date"
        style="position: relative; top: 1px"
        @change="changeDate">
      </el-date-picker>
      <el-input prefix-icon="el-icon-search"
                clearable
                v-model="searchText"
                style="width: 260px; margin-left: 10px;"
                placeholder="车牌号">
      </el-input>
      <el-button style="margin-left: 10px" @click="changeDate">查询</el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" border header-cell-class-name="table-head">
      <el-table-column fixed align="center" prop="carNo" label="车牌号" width="120"></el-table-column>
      <el-table-column fixed align="center" prop="technicianName" label="当前技师" width="100"></el-table-column>
      <el-table-column fixed align="center" label="当前工序" width="300">
        <template #default="{row}">
          <div>
            <label v-for="(_, index) in row.procedureList" :key="index">
              <label :style="stepPointStyle(row, index)"
                     style="display: inline-block; width: 10px; height: 10px; margin-bottom: -4px; ">
              </label>
              <label v-if="index < row.procedureList.length-1"
                     :style="{'background-color': index < row.curProcedureIndex ? '#1890ff' : 'gray'}"
                     style="display: inline-block; width: 37px; height: 2px; background-color: #1890ff">
              </label>
            </label>
          </div>
          <div>
            <label v-for="(procedure, index) in row.procedureList" :key="index"
                   :style="{'margin-left': (index === 0 ? 0 : 20) + 'px'}">
              {{procedure.second}}
            </label>
          </div>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header="{}">
          <div style="text-align: center">
            {{date.format('yyyy年MM月dd日') + getWeek(date.getDay())}}
          </div>
          <div style="text-align: center;">
            <div
              style="display: inline-block; width: 10px; height: 10px; background-color: #eaeaec; margin-right: 6px"></div>
            <label style="margin-right: 20px">预计时间</label>
            <div
              style="display: inline-block; width: 10px; height: 10px; background-color: #f2e4ca; margin-right: 6px"></div>
            <label>实际时间</label>
          </div>
        </template>
        <template #default="{row}">
          <div
            style="overflow-x: auto; height: 105px; overflow-y: hidden; border-left: 1px solid darkgrey; border-top: 1px solid darkgrey">
            <div :style="{width: timeList.length * timeColumnWidth + 'px'}">
              <div v-for="time in timeList" :key="time"
                   style="display: inline-block; background-color: #e7ece5; font-weight: bold; height: 30px; line-height: 30px; text-align: center; border-right: 1px solid darkgrey;"
                   :style="{'width': timeColumnWidth + 'px'}">
                {{time}}
              </div>
              <div style="height: 12px">
                <div v-for="(_, index) in timeList" :key="index"
                     style="display: inline-block;">
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                </div>
              </div>

              <div style="height: 20px">
                <div v-for="(section, index) in row.plan" :key="index"
                     style="display: inline-block; height: 20px; line-height: 20px; text-align: center; overflow: hidden; font-weight: bold"
                     :style="{width: section.length * timeColumnWidth / 4 + 'px',
                      'background-color': section.name? '#eaeaec' : '#00000000',
                      'border-right': '1px solid ' + (section.name ? 'black' : 'darkgrey')}">
                  {{section.name}}
                </div>
              </div>

              <div style="height: 12px">
                <div v-for="(_, index) in timeList" :key="index" style="display: inline-block;">
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                </div>
              </div>

              <div style="height: 20px">
                <div v-for="(section, index) in row.actual" :key="index"
                     style="display: inline-block; height: 20px; line-height: 20px; text-align: center; overflow: hidden; color: orange; font-weight: bold"
                     :style="{width: section.length* timeColumnWidth/4 + 'px',
                      'background-color': section.name? '#f2e4ca' : '#00000000',
                      'border-right': '1px solid ' + (section.name ? 'black' : 'darkgrey')}">
                  {{section.name}}
                </div>
              </div>

              <div style="height: 12px">
                <div v-for="(_, index) in timeList" :key="index"
                     style="display: inline-block;">
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                  <div class="grid" :style="gridStyle"></div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { workProgressList } from '@/utils/request'
  import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

  export default {
    name: 'WorkProcess',
    mixins: [resizeCaptureMixin],
    data () {
      return {
        loading: false,
        date: new Date(),
        searchText: null,
        workList: [],
        timeList: []
      }
    },
    created () {
      this.changeDate()
    },
    methods: {
      stepPointStyle (work, procedureIndex) {
        const beginWork = procedureIndex < work.curProcedureIndex ||
          (procedureIndex === work.curProcedureIndex && work.curProcedureProgress != null)
        return { 'background-color': beginWork ? '#1890ff' : 'gray' }
      },
      changeDate () {
        this.loading = true
        workProgressList(this.date.format('yyyy-MM-dd')).then(response => {
          this.timeList = response.data.timeList
          this.workList = response.data.workProgressList
        }).finally(() => {
          this.loading = false
        })
      },
      getWeek (index) {
        return '（周' + '日一二三四五六'[index] + '）'
      }
    },
    computed: {
      tableData () {
        if (!this.searchText) return this.workList

        return this.workList.filter(work => work.carNo.indexOf(this.searchText) !== -1)
      },
      timeColumnWidth () {
        return Math.max(80, (this.clientWidth - 524) / 4 * 4 / this.timeList.length)
      },
      gridStyle () {
        return {
          width: this.timeColumnWidth / 4 + 'px'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    th {
      height: 50px;
    }

    .el-table--small .el-table__cell {
      padding: 0 !important;
    }

    .cell {
      padding: 0 !important;
    }

    .el-table--border th.el-table__cell {
      border-bottom: 0;
    }

    .el-table .cell {
      line-height: normal !important;
    }
  }

  .fill-cell {
    height: 20px;
    background-color: #8fb4e2
  }

  .empty-cell {
    height: 20px;
    background-color: #dfdfe2;
    border-right: 1px solid darkgrey
  }

  .empty-cell-no-border {
    height: 20px;
    background-color: #dfdfe2;
  }

  .grid {
    display: inline-block;
    height: 12px;
    border-right: 1px solid darkgrey
  }
</style>
